<template>
  <div class="agent-password-update form-group">
    <div v-if="!passwordUpdated">
      <text-input
        class="subsection"
        :isMandatory="true"
        :label="form.passwordOld.label"
        :type="Types.Input.Password"
        :gacategory="gacategory"
        @validated-fields="validate"
        @input="onPasswordOldInput"
      />
      <text-input
        class="subsection"
        :label="form.passwordNew.label"
        :isMandatory="true"
        :type="Types.Input.Password"
        :gacategory="gacategory"
        :mustNotMatch="passwordOldValue"
        @validated-fields="validate"
        @input="onPasswordNewInput"
      />
      <text-input
        class="subsection"
        :isMandatory="true"
        :label="form.passwordConfirm.label"
        :type="Types.Input.Password"
        :gacategory="gacategory"
        :mustMatch="passwordNewValue"
        @validated-fields="validate"
        @input="onInput"
      />
      <span v-if="isError" id="error-message" class="error inline">
        {{ errorMsg }}
      </span>
          <oa-button
            class="subsection"
            :text="'Update'"
            :btnClass="{ color: 'green' }"
            :disabled="disableSubmit"
            :gacategory="gacategory"
            @click="clickedValidate"
          />
    </div>
    <div v-else class="ut-text-center">
        <svg-loader :name="'icon-check'" :width="20" :color-class="'ut-text-green-400'"  />
        <p class=" ut-font-bold ut-text-lg ut-my-4">Your password was updated successfully</p>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import OaButton from '@/components/Forms/OaButton.vue';
import TextInput from '@/components/Forms/TextInput.vue';
import FormHandler from '@/mixins/FormHandler';
import Types from '@/Mapper/CustomType';

export default {
  name: 'AccountPasswordUpdate',
  props: {
    gacategory: { default: null },
  },
  mixins: [
    FormHandler,
  ],
  components: {
    OaButton,
    TextInput,
    SvgLoader,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    passwordOldValue() {
      return this.form.passwordOld.values
        && this.form.passwordOld.values.value
        ? this.form.passwordOld.values.value
        : '';
    },
    passwordNewValue() {
      return this.form.passwordNew.values
        && this.form.passwordNew.values.value
        ? this.form.passwordNew.values.value
        : '';
    },
    passwordConfirmValue() {
      return this.form.passwordConfirm.values
        && this.form.passwordConfirm.values.value
        ? this.form.passwordConfirm.values.value
        : '';
    },
    gaLabel() {
      return `AID=${this.agent.id}`;
    },
    isError() {
      return this.errorMsg !== '';
    },
  },
  data() {
    return {
      disableSubmit: false,
      passwordUpdated: false,
      errorMsg: '',
      Types,
      form: {
        passwordOld: {
          label: 'Current password',
          values: {},
        },
        passwordNew: {
          label: 'New password',
          values: {},
        },
        passwordConfirm: {
          label: 'Confirm new password',
          values: {},
        },
      },
    };
  },
  methods: {
    saveDetails() {
      this.disableSubmit = true;
      this.errorMsg = '';
      const data = {
        username: this.agent.email,
        password: this.passwordOldValue,
        newpassword1: this.passwordNewValue,
        newpassword2: this.passwordConfirmValue,
      };
      this.$apiServices.oa.security.updatePassword(data)
        .then((userData) => {
          this.resetInputs();
          this.disableSubmit = false;
          this.passwordUpdated = true;
          // Open a validation pop-up?
          // Send GA event
          // this.$helpers.gaEvent(
          //   'AgentPortal',
          //   'Profile Settings Management - Updates password',
          //   this.gaLabel,
          // );
        })
        .catch((error) => {
          console.error(error);
          switch (error) {
            case 'Credentials are incorrect':
              this.errorMsg = 'Current password was entered incorrectly.';
              break;
            default:
              throw new Error(error);
          }
          this.disableSubmit = false;
        });
    },
    // gaEvent(eventAction, eventLabel) {
    //   const label = `AID=${this.agent.id}${eventLabel ? ` | ${eventLabel}` : ''}`;
    //   return {
    //     category: 'AgentPortal',
    //     action: eventAction,
    //     label,
    //   };
    // },
    onPasswordOldInput(values) {
      this.$emit(`${this.form.passwordNew.label}-set-value`, values.value, this.Types.Validation.MustNotMatch);
      this.onInput(values);
    },
    onPasswordNewInput(values) {
      this.$emit(`${this.form.passwordConfirm.label}-set-value`, values.value, this.Types.Validation.MustMatch);
      this.onInput(values);
    },
  },
};

</script>

<style lang="scss" scoped>

.btn {
  margin-bottom: 15px;
}

.hint {
  @apply ut-text-sm ut-font-light ut-tracking-normal;
}

.ut-flex .subsection {
  @apply ut-mx-2;
}

.subsection {
  @apply ut-p-2;
}

</style>
